import { distance, coordinates, offsetPoint } from "./planet.js";
export const ZONES = [
  {
    id: "welcome",
    name: "欢迎入口",
    point: [0, 17],
    spawn: [0, 7],
    title: "嗨，欢迎来到我的小星球。",
    description:
      "我是 Mimico。这里收藏着小小的灵感，也藏着一些等待你发现的惊喜。沿着小路走走吧，不用着急。",
    action: "让灵感亮起来",
    path: null,
  },
  {
    id: "inspiration",
    name: "中央灵感树",
    point: [0, 48],
    spawn: [0, 39],
    title: "每一个想法，都有发芽的可能。",
    description:
      "点击一片灵感，看看它会变成什么。这里的造景是主题演示，你也可以把自己的想法带到 Mimico。",
    action: "摘一片灵感",
    path: null,
  },
  {
    id: "studio",
    name: "创作小屋",
    point: [-40, 30],
    spawn: [-40, 19],
    title: "把脑海里的小世界，做出来。",
    description:
      "从一句描述开始，在预览中看到体验，再调整、发布。这是一个流程演示；真正的创作会在 Mimico 中打开。",
    action: "看看创作过程",
    path: "/create",
    linkLabel: "去创作一个世界",
  },
  {
    id: "works",
    name: "作品花园",
    point: [40, 30],
    spawn: [40, 19],
    title: "想法不同，世界也不同。",
    description:
      "一座可以探索的小山、一组等待拼合的积木、一场刚刚开始的故事。三种主题造景，展示可玩体验的不同可能。",
    action: "切换主题造景",
    path: "/discover",
    linkLabel: "发现更多体验",
  },
  {
    id: "share",
    name: "分享码头",
    point: [158, 28],
    spawn: [161, 18],
    title: "让你的世界，漂向更多人。",
    description:
      "把做好的作品发布，再把链接分享给朋友。就像这只小纸船，把一个小小的惊喜送到远方。",
    action: "放出一只纸船",
    path: "/",
    linkLabel: "打开 Mimico",
  },
  {
    id: "pocket",
    name: "口袋驿站",
    point: [78, -25],
    spawn: [78, -36],
    title: "喜欢的小世界，随身带着。",
    description:
      "在浏览器中发现与创作，用手机、平板继续体验。前往下载页查看当前可用的客户端。",
    action: "点亮另一台设备",
    path: "/download",
    linkLabel: "查看客户端下载",
  },
  {
    id: "quiet",
    name: "悄悄花园",
    point: [-65, -25],
    spawn: [-65, -36],
    title: "这里，允许你发一会儿呆。",
    description: "听听风，看看花。暂时没有想法也没关系，小星球随时欢迎你回来。",
    action: "叫醒一小簇花",
    path: null,
  },
];
export const SPAWN = ZONES[0].spawn;
// Interactions attach to the visible foreground prop, not the travel landing point.
export const FOCUS_OFFSETS = {
  welcome: [0, 3], inspiration: [0, 3.3], studio: [0, 3.6],
  works: [0, 2.6], share: [1.8, 2.6], pocket: [0, 3], quiet: [0, 3],
};
for (const zone of ZONES) zone.focus = offsetPoint(zone.point, ...FOCUS_OFFSETS[zone.id]);
export const COLLIDERS = ZONES.filter((z) => z.id !== "welcome").map((z) => ({
  point: z.point,
  radius: { studio: 2.8, works: 1.8, inspiration: 1.4, share: 1.3, pocket: 2.2, quiet: 1.2 }[z.id],
}));
export const ROUTES = [
  { points: [ZONES[0].spawn, [-22, 10], ZONES[2].spawn, [-58, -6], ZONES[6].spawn, [-123, -24], ZONES[4].spawn, [123, -12], ZONES[5].spawn, [58, -4], ZONES[3].spawn, [22, 10], ZONES[0].spawn], width: 2.8 },
  { points: [ZONES[2].spawn, [-27, 20], [-18, 34], ZONES[1].spawn, [18, 34], [27, 20], ZONES[3].spawn], width: 2 },
  { points: [ZONES[0].spawn, ZONES[1].spawn], width: 2 },
];
export function productHref(origin, path, introOrigin = "") {
  if (path == null || !origin?.trim()) return null;
  try {
    const base = new URL(origin);
    if (
      !["http:", "https:"].includes(base.protocol) ||
      base.username ||
      base.password
    )
      return null;
    if (introOrigin && base.origin === new URL(introOrigin).origin) return null;
    return new URL(path, base.origin).href;
  } catch {
    return null;
  }
}
export function canStand(longitude, latitude) {
  if (
    !Number.isFinite(longitude) ||
    !Number.isFinite(latitude) ||
    Math.abs(latitude) > 90
  )
    return false;
  return !COLLIDERS.some(
    (c) => distance([longitude, latitude], c.point) < c.radius + 0.45,
  );
}
export function nearestZone(position, range = 2.8) {
  const point = Array.isArray(position) ? position : coordinates(position);
  return (
    ZONES.map((zone) => ({ zone, d: distance(point, zone.focus) }))
      .filter((v) => v.d < range)
      .sort((a, b) => a.d - b.d)[0]?.zone ?? null
  );
}
